if ( typeof VariantPicker !== 'function' ) {

	class VariantPicker extends HTMLElement {

		constructor(){

			super();

			this.installmentPaymentType = "installment";
			this.normalPaymentType = "normal";
			this.hiddenVariantSelector = this.querySelectorAll('div[data-subscription]');
			this.variantOptionsForPurchaseCount = 0;
			this.isOtsPaymentAvailable = document.querySelector(".ots-payment-type");
			this._isSettingPaymentType = false; // Guard flag to prevent infinite loop
			this.listenersInitialized = false;

			this.initializePurchaseTypeListeners();

			this.querySelectorAll('.payment-type-unselect').forEach(option => {
				option.classList.add("display-none")
			  });

			// Adding selected selling plan to the cart drawer on change of variant
			this.querySelector('.product-variant__container__dropdown').addEventListener('change', this.setSellingPlanId.bind(this));
			
			// Handle radio button change events for payment type
			const paymentTypeContainer = this.querySelector('.product-payment-type--select');
			if (paymentTypeContainer) {
				const radioButtons = paymentTypeContainer.querySelectorAll('input[type="radio"].product-payment-type-radio');
				radioButtons.forEach(radio => {
					radio.addEventListener('change', () => {
						this.hideNonSubscriptionVariant();
						this.setSellingPlanId();
					});
				});
			}
      if (this.isOtsPaymentAvailable) {
        // Handle OTS payment type radio button changes
        const otsPaymentTypeContainer = this.querySelector(".product-ots-payment-type--select");
        if (otsPaymentTypeContainer) {
          const otsRadioButtons = otsPaymentTypeContainer.querySelectorAll('input[type="radio"].product-ots-payment-type-radio');
          otsRadioButtons.forEach(radio => {
            radio.addEventListener('change', () => {
              this.hideNonSubscriptionVariant("ots");
              this.setSellingPlanId();
            });
          });
        }
      }

			this.hideNonSubscriptionVariant(false, false);
			const isReturnsSKU =  document.getElementById("is_returns_sku")?.value || false;
			if (!isReturnsSKU) {
				this.setSellingPlanId();
			}

			this.onReloadingforShipmentAmount();
			this.variantChangeShipmentAmounthandler();
			this.variantChangePaymentType();
			this.querySelectorAll('.subscription-payment-type-selection').forEach((e)=>{
			e.addEventListener('change', () => {
			const subscriptionValue = e.value;
			if(subscriptionValue=="subscription"){
				this.onReloadingforShipmentAmount();
			}
			});
			});

			// resetting OTS variants incase of partner attribution serving doesn't match
			document.addEventListener('variant-picker:check-subscription', (e) => {
				this.checkVariantSubscription(false);
			});
			const urlSearchParams = new URLSearchParams(window.location.search);
            const isPartnerAttrFlow = ['subscription', '_paymentMethod', 'payment_type', 'servings'].some(param => urlSearchParams.has(param));
	  		if (!isPartnerAttrFlow) {
    			const defaultPurchaseType = KROWN.settings.product_default_purchaseType;
				const defaultPaymentType = KROWN.settings.product_default_paymentType;
				const oneTimeRadio = document.querySelector(".one-time-shipment-radio");
				const subscriptionRadio = document.querySelector(".subscription_option input[type='radio']");
				const paymentTypeDropdown = document.querySelector(".product-payment-type--select");

				if (defaultPurchaseType === "ots" && oneTimeRadio) {
					oneTimeRadio.dispatchEvent(new MouseEvent("click"));
					this.checkVariantSubscription(false);
					// Set OTS payment type based on default setting
					const otsPaymentContainer = this.querySelector(".product-ots-payment-type--select");
					if (otsPaymentContainer) {
						const targetOtsPaymentType = defaultPaymentType === "PayInFull" ? "normal" : "installment";
						const otsPaymentOptionRadio = this.getOtsPaymentTypeRadio(otsPaymentContainer, targetOtsPaymentType);
						if (otsPaymentOptionRadio) {
							otsPaymentOptionRadio.checked = true;
							otsPaymentOptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
						}
					}
				} else if (defaultPurchaseType === "subscription" && subscriptionRadio && this.variantOptionsForPurchaseCount > 0) {
					const isReturnsSKU =  document.getElementById("is_returns_sku")?.value || false;
					if (!isReturnsSKU) {
						this.setSellingPlanId();
					}
					this.onReloadingforShipmentAmount();
					subscriptionRadio.dispatchEvent(new MouseEvent("click"));
					this.checkVariantSubscription(true);
					if (paymentTypeDropdown) {
						const targetPaymentType = defaultPaymentType === "PayInFull" ? "normal" : "installment";
						const paymentOptionRadio = this.getPaymentTypeRadio(paymentTypeDropdown, targetPaymentType);
						if (paymentOptionRadio) {
							paymentOptionRadio.checked = true;
							paymentOptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
						}
					}
				}
			}
		}

		// Helper method to get payment type radio button value
		getPaymentTypeValue(container) {
			if (!container) return "";
			const radio = container.querySelector('input[type="radio"].product-payment-type-radio:checked');
			return radio ? radio.value : "";
		}

		// Helper method to set payment type radio button value
		setPaymentTypeValue(container, value) {
			if (!container) return;
			// Prevent infinite loop - don't dispatch if already setting payment type
			if (this._isSettingPaymentType) return;
			
			const radio = container.querySelector(`input[type="radio"].product-payment-type-radio[value="${value}"]`);
			if (radio && !radio.checked) {
				this._isSettingPaymentType = true;
				radio.checked = true;
				radio.dispatchEvent(new Event('change', { bubbles: true }));
				this._isSettingPaymentType = false;
			}
		}

		// Helper method to get payment type radio button by data-payment-type
		getPaymentTypeRadio(container, dataPaymentType) {
			if (!container) return null;
			return container.querySelector(`input[type="radio"].product-payment-type-radio[data-payment-type="${dataPaymentType}"]`) ||
				   container.querySelector(`label.product-variant-payment-type[data-payment-type="${dataPaymentType}"]`)?.querySelector('input[type="radio"]');
		}

		// Helper method to hide/show payment type radio options
		hidePaymentTypeOption(container, dataPaymentType, hide = true) {
			if (!container) return;
			const label = container.querySelector(`label.product-variant-payment-type[data-payment-type="${dataPaymentType}"]`);
			const radio = label?.querySelector('input[type="radio"]');
			
			if (label && radio) {
				if (hide) {
					label.classList.add('display-none');
					radio.disabled = true;
				} else {
					label.classList.remove('display-none');
					radio.disabled = false;
				}
			}
		}

		initializePurchaseTypeListeners(retryCount = 0) {
			if (this.listenersInitialized) {
				return;
			}

			const maxRetries = 3;
			const retryDelay = 100;

			const options = this.querySelectorAll('.purchase_type_options');

			if (options.length === 0 && retryCount < maxRetries) {
				setTimeout(() => {
					this.initializePurchaseTypeListeners(retryCount + 1);
				}, retryDelay);
				return;
			}

			options.forEach(option => {
				const radioInput = option.querySelector('input[type="radio"]');

				if (radioInput) {
					radioInput.addEventListener('change', this.checkVariantSubscriptionHandler.bind(this));
				} else if (retryCount < maxRetries) {
					setTimeout(() => {
						this.initializePurchaseTypeListeners(retryCount + 1);
					}, retryDelay);
					return;
				} else {
					console.warn('VariantPicker: Could not find radio input for purchase_type_options', option);
				}

				option.addEventListener('keydown', this.handleKeydown);
			});

			if (options.length > 0) {
				this.listenersInitialized = true;
			}
		}

		connectedCallback() {
			if (!this.listenersInitialized) {
				this.initializePurchaseTypeListeners();
			}
		}

		handleKeydown(event) {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				const radioInput = this.querySelector('input[type="radio"]');
				if (radioInput) {
					radioInput.checked = true;
					radioInput.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}
		}

		// Helper method to get first visible payment type value
		getFirstVisiblePaymentTypeValue(container) {
			if (!container) return "";
			const visibleRadio = container.querySelector('input[type="radio"].product-payment-type-radio:not(:disabled)');
			if (visibleRadio && !visibleRadio.closest('label').classList.contains('display-none')) {
				return visibleRadio.value;
			}
			return "";
		}

		// ========== OTS Payment Type Radio Helper Methods ==========
		
		// Helper method to get OTS payment type radio button value
		getOtsPaymentTypeValue(container) {
			if (!container) return "";
			const radio = container.querySelector('input[type="radio"].product-ots-payment-type-radio:checked');
			return radio ? radio.value : "";
		}

		#getOtsPaymentTypeDataValue(container) {
			if (!container) return "";
			const radio = container.querySelector('input[type="radio"].product-ots-payment-type-radio:checked');
			return radio?.getAttribute('data-payment-type') || "";
		}

		#getDefaultPaymentTypeValue() {
			const defaultPaymentType = typeof KROWN !== 'undefined' && KROWN.settings
				? KROWN.settings.product_default_paymentType
				: '';
			return defaultPaymentType === 'PayInFull' ? this.normalPaymentType : this.installmentPaymentType;
		}

		#resolvePaymentTypeValue(isOTS, paymentTypeDropdown, otsPaymentContainer) {
			if (isOTS) {
				// Markets without OTS installment radios only have pure one-time variants.
				if (!this.isOtsPaymentAvailable) {
					return this.normalPaymentType;
				}
				const otsPaymentType = this.#getOtsPaymentTypeDataValue(otsPaymentContainer);
				if (otsPaymentType) {
					return otsPaymentType;
				}
				return this.#getDefaultPaymentTypeValue();
			}

			const newPaymentTypeVar = this.getPaymentTypeValue(paymentTypeDropdown);
			if (newPaymentTypeVar !== "") {
				return newPaymentTypeVar === KROWN.settings.locales.products_payment_type_shipment
					? this.normalPaymentType
					: this.installmentPaymentType;
			}
			return this.#getDefaultPaymentTypeValue();
		}

		#ensureVariantSelection() {
			const variantSelect = this.#getVariantSelect();
			if (!variantSelect) return;

			const visibleOptions = this.#getVisibleSelectOptions();
			if (!visibleOptions.length) {
				return;
			}

			const selectedOption = variantSelect.selectedOptions[0] ||
				this.querySelector(`.product-variant-dropdown-value[value="${variantSelect.value}"]`);

			if (!this.#isSelectOptionVisible(selectedOption)) {
				variantSelect.value = visibleOptions[0].value;
				variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
			}
		}

		#isOtsDisabledSubscription(element) {
			return element.dataset.subscription !== "" &&
				element.dataset.oneTimeShipmentDisabled === "true";
		}

		#filterOtsVariantOptions(paymentTypeValue) {
			const effectivePaymentType = this.isOtsPaymentAvailable
				? paymentTypeValue
				: this.normalPaymentType;

			this.hiddenVariantSelector.forEach(element => {
				const variantOption = this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`);
				if (!variantOption) {
					return;
				}

				const isPureOts = element.dataset.paymentType === "" && element.dataset.subscription === "";
				const isInstallmentSub =
					element.dataset.paymentType === this.installmentPaymentType &&
					element.dataset.subscription !== "";
				const isDisabledSub = this.#isOtsDisabledSubscription(element);

				if (!this.isOtsPaymentAvailable) {
					if (isInstallmentSub || isDisabledSub) {
						this.#hideVariantOption(variantOption);
					} else {
						this.#showVariantOption(variantOption);
					}
					return;
				}

				if (effectivePaymentType === this.normalPaymentType) {
					if (isPureOts) {
						this.#showVariantOption(variantOption);
					} else {
						this.#hideVariantOption(variantOption);
					}
					return;
				}

				if (isInstallmentSub) {
					this.#showVariantOption(variantOption);
				} else {
					this.#hideVariantOption(variantOption);
				}
			});
		}

		#ensureOtsVisibleOptions(paymentTypeValue) {
			if (this.#getVisibleSelectOptions().length) {
				return;
			}

			const effectivePaymentType = this.isOtsPaymentAvailable
				? paymentTypeValue
				: this.normalPaymentType;

			for (const element of this.hiddenVariantSelector) {
				const variantOption = this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`);
				if (!variantOption) continue;

				const isPureOts = element.dataset.paymentType === "" && element.dataset.subscription === "";
				const isSubscriptionNormal =
					element.dataset.subscription !== "" &&
					element.dataset.paymentType !== this.installmentPaymentType;

				if (
					effectivePaymentType === this.normalPaymentType &&
					(isPureOts || (!this.isOtsPaymentAvailable && isSubscriptionNormal && !this.#isOtsDisabledSubscription(element)))
				) {
					this.#showVariantOption(variantOption);
					return;
				}

				if (
					this.isOtsPaymentAvailable &&
					effectivePaymentType === this.installmentPaymentType &&
					element.dataset.paymentType === this.installmentPaymentType &&
					element.dataset.subscription !== ""
				) {
					this.#showVariantOption(variantOption);
					return;
				}
			}

			if (effectivePaymentType === this.normalPaymentType) {
				for (const element of this.hiddenVariantSelector) {
					if (element.dataset.paymentType !== "" || element.dataset.subscription !== "") continue;

					const variantOption = this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`);
					if (variantOption) {
						this.#showVariantOption(variantOption);
						return;
					}
				}
			}
		}

		// Helper method to set OTS payment type radio button value
		setOtsPaymentTypeValue(container, value) {
			if (!container) return;
			const radio = container.querySelector(`input[type="radio"].product-ots-payment-type-radio[value="${value}"]`);
			if (radio && !radio.checked) {
				radio.checked = true;
				radio.dispatchEvent(new Event('change', { bubbles: true }));
			}
		}

		// Helper method to get OTS payment type radio button by data-payment-type
		getOtsPaymentTypeRadio(container, dataPaymentType) {
			if (!container) return null;
			return container.querySelector(`input[type="radio"].product-ots-payment-type-radio[data-payment-type="${dataPaymentType}"]`) ||
				   container.querySelector(`label.product-ots-variant-payment-type[data-payment-type="${dataPaymentType}"]`)?.querySelector('input[type="radio"]');
		}

		// Helper method to hide/show OTS payment type radio options
		hideOtsPaymentTypeOption(container, dataPaymentType, hide = true) {
			if (!container) return;
			const label = container.querySelector(`label.product-ots-variant-payment-type[data-payment-type="${dataPaymentType}"]`);
			const radio = label?.querySelector('input[type="radio"]');
			
			if (label && radio) {
				if (hide) {
					label.classList.add('display-none');
					radio.disabled = true;
				} else {
					label.classList.remove('display-none');
					radio.disabled = false;
				}
			}
		}

		// Helper method to get first visible OTS payment type value
		getFirstVisibleOtsPaymentTypeValue(container) {
			if (!container) return "";
			const visibleRadio = container.querySelector('input[type="radio"].product-ots-payment-type-radio:not(:disabled)');
			if (visibleRadio && !visibleRadio.closest('label').classList.contains('display-none')) {
				return visibleRadio.value;
			}
			return "";
		}

		/**
		 * Normalize variant title by removing trailing dot and trimming whitespace
		 * This helps match OTS variants (with dot) to Subscription variants (without dot)
		 * @param {string} title - The variant title to normalize
		 * @returns {string} - Normalized title
		 */
		normalizeVariantTitle(title) {
			if (!title) return "";
			return title.trim().replace(/\.$/, "").trim();
		}

		/**
		 * Find matching variant option using SKU-based matching
		 * Handles both OTS ↔ Subscription and Payment Frequency (normal ↔ installment) matching
		 * SKU relationships: OTS and subscription normal share same SKU, installment has "inst_" prefix
		 * @param {string} currentValue - Current selected option's value
		 * @param {Object} matchCriteria - Matching criteria object
		 * @param {boolean} matchCriteria.isSubscription - Whether current selection is subscription variant (for OTS ↔ Subscription matching)
		 * @param {string} matchCriteria.currentPaymentType - Current payment type: "normal" or "installment" (for Payment Frequency matching)
		 * @param {string} matchCriteria.matchBy - Match type: "subscription" or "paymentType"
		 * @param {NodeList} visibleOptions - Visible and enabled option elements to search in
		 * @param {HTMLElement} currentOption - Current selected option element
		 * @returns {HTMLElement|null} - The matching option element or null
		 */
		findMatchingVariantOption(currentValue, matchCriteria, visibleOptions, currentOption = null) {
			console.log('Adding console log for findMatchingVariantOption');
			// Backward compatibility: if matchCriteria is boolean, treat as isSubscription
			const isLegacyCall = typeof matchCriteria === 'boolean';
			const criteria = isLegacyCall 
				? { isSubscription: matchCriteria, matchBy: 'subscription' }
				: matchCriteria;

			if (!currentValue || !visibleOptions) return null;

			// Get current SKU from the current option's data attribute (if provided)
			// or find the current option from the dropdown
			let currentSku = "";
			if (currentOption && currentOption.dataset.variantSku) {
				currentSku = currentOption.dataset.variantSku.trim();
			} else {
				// Fallback: find current option by value
				const currentOpt = Array.from(visibleOptions).find(opt => opt.value === currentValue) ||
					this.querySelector(`.product-variant-dropdown-value[value="${currentValue}"]`);
				if (currentOpt && currentOpt.dataset.variantSku) {
					currentSku = currentOpt.dataset.variantSku.trim();
				}
			}

			if (!currentSku) {
				console.log('[VariantPicker] findMatchingVariantOption - No SKU found for current value:', currentValue);
				return null;
			}
			
			// Determine the base SKU and installment SKU
			const baseSku = currentSku.startsWith("inst_") ? currentSku.replace("inst_", "") : currentSku;
			const installmentSku = "inst_" + baseSku;

			for (const option of visibleOptions) {
				// Get SKU and subscription/payment info directly from the option's data attributes
				const optionSku = option.dataset.variantSku?.trim() || "";
				
				if (!optionSku) continue;

				// Read subscription and payment type directly from the option (no metadata lookup needed)
				const isOptionSubscription = option.dataset.subscription !== undefined && option.dataset.subscription !== "";
				const optionPaymentType = option.dataset.paymentType || "";

				if (criteria.matchBy === 'subscription') {
					// OTS ↔ Subscription matching
					// We want the opposite subscription type with matching SKU
					if (isOptionSubscription === criteria.isSubscription) {
						continue;
					}

					// Match by SKU: OTS and subscription normal share the same base SKU
					if (optionSku === baseSku || optionSku === installmentSku) {
						return option;
					}
				} else if (criteria.matchBy === 'paymentType') {
					// Payment Frequency matching (normal ↔ installment)
					const currentPaymentType = criteria.currentPaymentType || "";

					// Both must be subscription variants
					if (!isOptionSubscription) {
						continue;
					}

					// We want the opposite payment type
					if (optionPaymentType === currentPaymentType) {
						continue;
					}

					// Match by SKU relationship
					// If current is normal (baseSku), look for installment (inst_baseSku)
					// If current is installment (inst_baseSku), look for normal (baseSku)
					if (currentPaymentType === 'normal' && optionSku === installmentSku) {
						return option;
					}
					if (currentPaymentType === 'installment' && optionSku === baseSku) {
						return option;
					}
				}
			}

			return null;
		}

		onClearSubscriptionDetails() {
			const spanElement = document.querySelector('.sub_details');
			const deliveryPolicyIntervalElement = this.querySelector('.delivery-policy-interval');
			const deliveryPolicyIntervalCountElement = this.querySelector('.delivery-policy-interval-count');
			if (deliveryPolicyIntervalElement) {
				deliveryPolicyIntervalElement.value = "";
			}
			if (deliveryPolicyIntervalCountElement) {
				deliveryPolicyIntervalCountElement.value = "";
			}
			if (spanElement) {
				spanElement.innerHTML = "";
			}

			// Clear and hide subscription delivery element
			const iconSentenceDelivery = document.querySelector('.icon-sentence-text-subscription-delivery');
			if (iconSentenceDelivery) {
				iconSentenceDelivery.textContent = "";
				if (iconSentenceDelivery.closest('.icon-sentence')) {
					iconSentenceDelivery.closest('.icon-sentence').style.display = 'none';
				}
			}

			// Clear frequency note (per shipment interval)
			const frequencyNote = document.querySelector('.frequency-note[data-js-interval-note]');
			if (frequencyNote) {
				frequencyNote.textContent = "";
				frequencyNote.style.display = 'none';
			}
		}

		retrieveDeliveryPolicyByVariantId() {
			const variantId = this.querySelector('.variant-with-selling-plan-allocation')?.value;
			if(!variantId) {
				this.onClearSubscriptionDetails();
				return;
			}
			const apiUrl = KROWN.settings.subscription_api.get_selling_plan_info_by_variant_id
			const spanElement = document.querySelector('.sub_details');
			const mappedIntervalToLocale = {
				"day": KROWN.settings.locales.days,
				"week": KROWN.settings.locales.weeks,
				"month": KROWN.settings.locales.months,
				"year": KROWN.settings.locales.years
			};
			fetch(`${jpapp.proxyUrl}${apiUrl}?variantId=${variantId}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
			})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`API returned ${response.status}`);
				}
				return response.json();
			})
			.then((sellingPlanInfo) => {
				const { sellingPlan: { deliveryPolicy, originalIntervalCount, sellingPlanType  }, error } = sellingPlanInfo;
				const isInstallment = sellingPlanType === "installment";
				if (error) {
					throw new Error("Error fetching selling plan info");
				}
				const deliveryPolicyIntervalElement = this.querySelector('.delivery-policy-interval');
				const deliveryPolicyIntervalCountElement = this.querySelector('.delivery-policy-interval-count');
				if (deliveryPolicyIntervalElement) {
					deliveryPolicyIntervalElement.value = deliveryPolicy.interval;
				}
				if (deliveryPolicyIntervalCountElement) {
					deliveryPolicyIntervalCountElement.value = isInstallment ? originalIntervalCount : deliveryPolicy.intervalCount;
				}
				const localizedString = KROWN.settings.locales.subscription_details;
				const updatedString = localizedString
					.replace('{{ interval }}', mappedIntervalToLocale[deliveryPolicy.interval.toLowerCase()] )
					.replace('{{ intervalCount }}', deliveryPolicy.intervalCount);
				if (spanElement) {
					spanElement.innerHTML = updatedString;
				}

				// Update subscription delivery element (Element 1) - same text as sub_details
				const iconSentenceDelivery = document.querySelector('.icon-sentence-text-subscription-delivery');
				if (iconSentenceDelivery) {
					iconSentenceDelivery.textContent = updatedString;
					if (iconSentenceDelivery.closest('.icon-sentence')) {
						iconSentenceDelivery.closest('.icon-sentence').style.display = '';
					}
				}

				// Update frequency note for "Per shipment" option (Element 2) - shorter format "every X Month(s)"
				const frequencyNote = document.querySelector('.frequency-note[data-js-interval-note]');
				if (frequencyNote) {
					const intervalNoteString = KROWN.settings.locales.subscription_interval_note
						.replace('{{ intervalCount }}', deliveryPolicy.intervalCount)
						.replace('{{ interval }}', mappedIntervalToLocale[deliveryPolicy.interval.toLowerCase()]);
					frequencyNote.textContent = intervalNoteString;
					frequencyNote.style.display = '';
				}
			}).catch((e) => {
				console.log(e);
				this.onClearSubscriptionDetails();
			});
		}

		#getVariantSelect() {
			return this.querySelector('.product-variant-select');
		}

		#initVariantOptionOrder() {
			if (this._variantOptionOrder) return;

			this._variantOptionOrder = Array.from(
				this.querySelectorAll('.product-variant-dropdown-value')
			).map((option) => option.value);
		}

		#getVariantOptionStash() {
			if (!this._variantOptionStash) {
				this._variantOptionStash = document.createElement('div');
				this._variantOptionStash.hidden = true;
				this._variantOptionStash.setAttribute('aria-hidden', 'true');
				this.appendChild(this._variantOptionStash);
			}

			return this._variantOptionStash;
		}

		#showVariantOption(option) {
			if (!option) return;

			const select = this.#getVariantSelect();
			if (!select) return;

			this.#initVariantOptionOrder();
			option.disabled = false;
			option.classList.remove('display-none');
			option.hidden = false;
			option.removeAttribute('hidden');

			if (option.parentElement === select) return;

			const visibleOptions = this.#getVisibleSelectOptions();
			const order = this._variantOptionOrder || [];
			const optionIndex = order.indexOf(option.value);
			let inserted = false;

			for (const visibleOption of visibleOptions) {
				const visibleIndex = order.indexOf(visibleOption.value);
				if (visibleIndex > optionIndex) {
					select.insertBefore(option, visibleOption);
					inserted = true;
					break;
				}
			}

			if (!inserted) {
				select.appendChild(option);
			}
		}

		#hideVariantOption(option) {
			if (!option) return;

			const select = this.#getVariantSelect();
			if (!select || option.parentElement !== select) return;

			option.disabled = true;
			option.classList.add('display-none');
			option.hidden = true;
			this.#getVariantOptionStash().appendChild(option);
		}

		#showAllVariantOptions() {
			const select = this.#getVariantSelect();
			if (!select) return;

			this.#initVariantOptionOrder();

			const stashedOptions = Array.from(
				this.#getVariantOptionStash().querySelectorAll('.product-variant-dropdown-value')
			);

			for (const option of stashedOptions) {
				this.#showVariantOption(option);
			}
		}

		#getVisibleSelectOptions() {
			const select = this.#getVariantSelect();
			if (!select) return [];

			return Array.from(select.querySelectorAll('.product-variant-dropdown-value:not([disabled])'));
		}

		#isSelectOptionVisible(option) {
			return !!option && option.parentElement === this.#getVariantSelect() && !option.disabled;
		}

		#getCurrentVariantSelectionSnapshot() {
			const variantSelect = this.#getVariantSelect();
			if (!variantSelect || variantSelect.selectedIndex < 0) return null;

			const selectedOption = variantSelect.options[variantSelect.selectedIndex];
			if (!selectedOption) return null;

			return {
				value: selectedOption.value || "",
				sku: selectedOption.dataset.variantSku?.trim() || "",
				isSubscription: selectedOption.dataset.subscription !== undefined && selectedOption.dataset.subscription !== "",
				paymentType: selectedOption.dataset.paymentType || "",
				option: selectedOption
			};
		}

		//this function is called on page load and everytime the user changes the purchase type radio buttons
		hideNonSubscriptionVariant(isOTS, selectSubscriptionPlan = true) {
			if (this._isFilteringVariants) {
				return;
			}
			this._isFilteringVariants = true;

			try {
			const previousSelection = this.#getCurrentVariantSelectionSnapshot();
			if (isOTS) {
				const oneTimeRadio = this.querySelector(".one-time-shipment-radio");
				if (oneTimeRadio && !oneTimeRadio.checked) {
					oneTimeRadio.checked = true;
				}
			} else if (selectSubscriptionPlan) {
				this.querySelector('input[data-has-subscription-plans]').click();
			}
			let variantOptionsForPurchase = 0, installmentOptionCount = 0, normalOptionCount = 0;
			const dropdownContainerOptions = this.querySelectorAll('.product-variant-dropdown-value');
			const paymentTypeDropdown = this.querySelector('.product-payment-type--select');

			// emptying the value of the span which shows the variant if there is only one available
			this.querySelector('.selected_subscription_option').innerHTML = "";

			// Restore all options before applying the next filter (Safari ignores hidden <option> elements)
			this.#initVariantOptionOrder();
			this.#showAllVariantOptions();
			dropdownContainerOptions.forEach(item => {
				item.classList.remove('display-none');
				item.disabled = false;
			});
			// Reset payment type options visibility
			if (paymentTypeDropdown) {
				this.hidePaymentTypeOption(paymentTypeDropdown, this.normalPaymentType, false);
				this.hidePaymentTypeOption(paymentTypeDropdown, this.installmentPaymentType, false);
			}
			if (this.isOtsPaymentAvailable) {
				// Reset OTS payment type radio options visibility
				const otsPaymentContainer = this.querySelector(".product-ots-payment-type--select");
				if (otsPaymentContainer) {
				this.hideOtsPaymentTypeOption(otsPaymentContainer, this.normalPaymentType, false);
				this.hideOtsPaymentTypeOption(otsPaymentContainer, this.installmentPaymentType, false);
				}
			}
			this.querySelectorAll('.product-variant-container-box').forEach((el) => {
				el.classList.remove('display-none');
			});
			
			// count for the amount of variants
			this.hiddenVariantSelector.forEach(element => {
				if (element.getAttribute('data-subscription') !== "") variantOptionsForPurchase++;
				if (element.getAttribute('data-payment-type') !== "") {
					element.getAttribute('data-payment-type') === this.normalPaymentType ? normalOptionCount++ : installmentOptionCount++;
				}
				if (element.hasAttribute("data-linked_sku-available") && element.dataset.linked_skuAvailable !== "") {
					this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`).setAttribute("data-linked_sku-available",element.dataset.linked_skuAvailable);
				}
			})

			const hasNoNormalOption = normalOptionCount === 0;
			const hasNoInstallmentOption = installmentOptionCount === 0;
			if (hasNoNormalOption || hasNoInstallmentOption) {
				let optionPaymentType = hasNoNormalOption ? this.normalPaymentType : this.installmentPaymentType;
				if (paymentTypeDropdown) {
					this.hidePaymentTypeOption(paymentTypeDropdown, optionPaymentType, true);
					const firstVisibleValue = this.getFirstVisiblePaymentTypeValue(paymentTypeDropdown);
					if (firstVisibleValue) {
						this.setPaymentTypeValue(paymentTypeDropdown, firstVisibleValue);
					}
				}
				//ots
				if (this.isOtsPaymentAvailable) {
					const otsPaymentContainer = this.querySelector(".product-ots-payment-type--select");
					if (otsPaymentContainer) {
						optionPaymentType = hasNoInstallmentOption ? this.installmentPaymentType : this.normalPaymentType;
						this.hideOtsPaymentTypeOption(otsPaymentContainer, optionPaymentType, true);
						const firstVisibleOtsValue = this.getFirstVisibleOtsPaymentTypeValue(otsPaymentContainer);
						if (firstVisibleOtsValue) {
							this.setOtsPaymentTypeValue(otsPaymentContainer, firstVisibleOtsValue);
						}
					}
				}
			}

      const otsPaymentContainer = this.querySelector(".product-ots-payment-type--select");
      const paymentTypeValue = this.#resolvePaymentTypeValue(isOTS, paymentTypeDropdown, otsPaymentContainer);

			if (isOTS) {
				this.#filterOtsVariantOptions(paymentTypeValue);
			} else if (variantOptionsForPurchase >= 1) {

				this.hiddenVariantSelector.forEach(element => {
					if (element.dataset.paymentType === "" || element.dataset.paymentType !== paymentTypeValue) {
						const variantOption = this.querySelector(`.product-variant-dropdown-value[value="${element.dataset.variantName}"]`);
						if (variantOption) {
							this.#hideVariantOption(variantOption);
						}
					};
				});
			}

			if (isOTS || variantOptionsForPurchase >= 1) {
				// <--- Changes from ECOM-214 - Retain user selection --->
				const variantSelect = this.#getVariantSelect();
				const selectedContext = previousSelection || this.#getCurrentVariantSelectionSnapshot();
				if (variantSelect && selectedContext) {
					const selectedOption = selectedContext.option || this.querySelector(`.product-variant-dropdown-value[value="${selectedContext.value}"]`);
					const isCurrentValueValid = this.#isSelectOptionVisible(selectedOption);

					if (isCurrentValueValid) {
						if (variantSelect.value !== selectedContext.value) {
							variantSelect.value = selectedContext.value;
							variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
						}
					} else if (selectedContext.value) {
						const visibleOptions = this.#getVisibleSelectOptions();
						const currentSku = selectedContext.sku || selectedOption?.dataset.variantSku?.trim() || "";
						const isCurrentSubscription = selectedContext.isSubscription;
						const currentPaymentType = selectedContext.paymentType || "";

						if (currentSku) {
							// Determine matching strategy based on context - scenarios are mutually exclusive
							let matchingOption = null;
							
							// Scenario 1: Payment Frequency matching (normal ↔ installment) within subscription
							// Only applies when: current is subscription, not switching to OTS, and payment types differ
							const isPaymentFrequencyChange = isCurrentSubscription && !isOTS && 
								currentPaymentType !== "" && paymentTypeValue !== "" && 
								currentPaymentType !== paymentTypeValue;

							// Israel OTS installments: subscription per-shipment → OTS installment pool (same inst_ SKU)
							const isOtsInstallmentFromSubscriptionNormal = isOTS &&
								this.isOtsPaymentAvailable &&
								paymentTypeValue === this.installmentPaymentType &&
								isCurrentSubscription &&
								currentPaymentType === this.normalPaymentType;
							
							if (isPaymentFrequencyChange) {
								matchingOption = this.findMatchingVariantOption(
									selectedContext.value,
									{
										matchBy: 'paymentType',
										currentPaymentType: currentPaymentType
									},
									visibleOptions,
									selectedOption
								);
							} else if (isOtsInstallmentFromSubscriptionNormal) {
								matchingOption = this.findMatchingVariantOption(
									selectedContext.value,
									{
										matchBy: 'paymentType',
										currentPaymentType: currentPaymentType
									},
									visibleOptions,
									selectedOption
								);
							}
							// Scenario 2: OTS ↔ Subscription matching (purchase type change)
							else {
								matchingOption = this.findMatchingVariantOption(
									selectedContext.value,
									{
										matchBy: 'subscription',
										isSubscription: isCurrentSubscription
									},
									visibleOptions,
									selectedOption
								);
							}

							if (matchingOption) {
								// Found matching variant with same serving/packaging, select it
								variantSelect.value = matchingOption.value;
								variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
							} else {
								// No matching variant found, fall back to first visible option
								const firstVisibleOption = this.#getVisibleSelectOptions()[0];
								if (firstVisibleOption) {
									variantSelect.value = firstVisibleOption.value;
									variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
								} else {
								}
							}
						} else {
							const firstVisibleOption = this.#getVisibleSelectOptions()[0];
							if (firstVisibleOption) {
								variantSelect.value = firstVisibleOption.value;
								variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
							}
						}
					} else if (isCurrentValueValid) {
						console.log('[VariantPicker] hideNonSubscriptionVariant - Current selection is still valid, keeping it');
					}
				} else {
					console.log('[VariantPicker] hideNonSubscriptionVariant - No variant select found or no selection');
				}

				this.#ensureVariantSelection();
				if (isOTS) {
					this.#ensureOtsVisibleOptions(paymentTypeValue);
					this.#ensureVariantSelection();
				}

				// only per shipment case
				const paymentTypeValueText = this.getPaymentTypeValue(paymentTypeDropdown);
				if (!isOTS && (variantOptionsForPurchase === 1 || (normalOptionCount === 1 && paymentTypeValueText === KROWN.settings.locales.products_payment_type_shipment) || (installmentOptionCount === 1 && paymentTypeValueText === KROWN.settings.locales.products_payment_type_installment))) {				
					this.querySelectorAll('.product-variant-container-box').forEach((el) => {
						el.classList.add('display-none');
					});
					this.querySelector('.selected_subscription_option').innerHTML = this.querySelector('.product-variant-select').value;
				}
			}
			else {
				const oneTimeShipmentRadio = this.querySelector('.one-time-shipment-radio');
				if (oneTimeShipmentRadio && !oneTimeShipmentRadio.checked) {
					oneTimeShipmentRadio.checked = true;
				}
        // ots
        const paymentTypeValueText = this.getPaymentTypeValue(paymentTypeDropdown);
        if (
          variantOptionsForPurchase === 1 ||
          (normalOptionCount === 1 &&
            paymentTypeValueText ===
              KROWN.settings.locales.products_payment_type_shipment) ||
          (installmentOptionCount === 1 &&
            paymentTypeValueText ===
              KROWN.settings.locales.products_payment_type_installment)
        ) {
		  this.querySelectorAll(".product-variant-container-box").forEach((el) => {
			el.classList.add("display-none");
		  });
          this.querySelector(".selected_subscription_option").innerHTML =
            this.querySelector(".product-variant-select").value;
        }
				this.querySelector('.subscription_option').classList.add('display-none');
			}
			this.variantOptionsForPurchaseCount = variantOptionsForPurchase;
			} finally {
				this._isFilteringVariants = false;
			}
		}

		checkVariantSubscriptionHandler(event) {
			this.checkVariantSubscription(event.target.hasAttribute('data-has-subscription-plans'));
		}

    checkVariantSubscription(hasSubscriptionPlans) {
	  const isReturnsSKU = document.getElementById("is_returns_sku")?.value || false;

      if (hasSubscriptionPlans && !isReturnsSKU) {
        this.querySelector('.subscription-payment-type').classList.remove('display-none');
        if (this.isOtsPaymentAvailable) {
          this.querySelector(".ots-payment-type").classList.add("display-none"); //ots
        }
        this.hideNonSubscriptionVariant();
        this.setSellingPlanId();
        this.retrieveDeliveryPolicyByVariantId();
      } else if (isReturnsSKU) {
        this.querySelector(".subscription-payment-type").classList.add("display-none");
        this.querySelector(".ots-payment-type")?.classList.add("display-none");
      } else {
        this.closest('.product-text').querySelector('#subscription_type').value = "";
        this.closest('.product-text').querySelector('#selling_plan_selection').value = "";
        this.querySelector('.selected_subscription_option').innerHTML = "";
        this.closest('.product-text').querySelector('#selling_plan_properties').value = "";
		this.querySelectorAll(".product-variant-container-box").forEach((el) => {
			el.classList.remove("display-none");
		});
        this.closest('.product-text').querySelector('#selling_plan_name').value = "";

        this.querySelector('.subscription-payment-type').classList.add('display-none');

        if (this.isOtsPaymentAvailable) {
          this.querySelector(".ots-payment-type").classList.remove("display-none");
        }
        this.hideNonSubscriptionVariant("ots");
        if (this.isOtsPaymentAvailable) {
          this.setSellingPlanId();
        }
        this.onClearSubscriptionDetails();
      }
    }

	setSellingPlanId() {
		// Fix the null radio button issue by adding proper null check
		const selectedRadio = this.querySelector('input[type="radio"].subscription-payment-type-selection:checked');
		const selectedSubscriptionRadioValue = selectedRadio ? selectedRadio.value : 'one-time'; // Default to one-time if no radio is checked
		const otsPaymentRadio = this.isOtsPaymentAvailable && this.querySelector(".product-ots-payment-type--select input[type='radio'].product-ots-payment-type-radio:checked");
		const selectedOtsSelectValue = otsPaymentRadio ? otsPaymentRadio.value : ''; //ots
		const isOtsInstallment = selectedSubscriptionRadioValue === "one-time" && selectedOtsSelectValue === KROWN.settings.locales.products_ots_payment_type_installment;
		
		this.closest('.product-text').querySelector('#subscription_type').value = "";
		this.closest('.product-text').querySelector('#selling_plan_selection').value = "";
		this.closest(".product-text").querySelector("#selling_plan_name").value = "";
		this.closest(".product-text").querySelector("#ots_payment_selection").value = "";
     	this.closest(".product-text").querySelector("#ots_payment_selection_properties").value = isOtsInstallment;
     	this.closest(".product-text").querySelector("#selling_plan_properties").value = "";
		const variantDropdownGet = this.querySelector('.product-variant__container__dropdown');
			this.hiddenVariantSelector.forEach(element => {
				if (
					element.getAttribute('data-variant-name') === variantDropdownGet.value &&
					element.getAttribute('data-subscription') !== "" &&
					(selectedSubscriptionRadioValue === "subscription" || isOtsInstallment)
				) {
          const subscriptionName = element.getAttribute("data-subscription-name");
          this.closest(".product-text").querySelector("#selling_plan_name").value = isOtsInstallment ? KROWN.settings.ots.ots_selling_plan_name : subscriptionName;
					this.closest('.product-text').querySelector('#subscription_type').value = element.getAttribute('data-payment-type');
					this.closest('.product-text').querySelector('#selling_plan_selection').value = element.getAttribute('data-subscription');
          this.closest(".product-text").querySelector(
            "#ots_payment_selection"
          ).value = isOtsInstallment ? "OTS-Installment" : "";
          this.closest(".product-text").querySelector(
            "#ots_payment_selection_properties"
          ).value = isOtsInstallment;
				}
			});
		}
		
		/** update span element with change in variant shipment amount */
		variantChangeShipmentAmounthandler (){
			const shipmentAmountBox = document.querySelector('.product-variant-shipment-amount');
			shipmentAmountBox.addEventListener('change', () => {
				const selectedText = shipmentAmountBox.value.trim();

				const selectedVariant = [...document.querySelectorAll(".hidden-variant-dropdown div")].find(
					(div) => div.innerHTML.trim() == selectedText
				);
				if(selectedVariant){
					const variantId = selectedVariant.getAttribute("Value");
					this.onChangeVariantforShipmentAmount(variantId);
				}
				});	
		}

		/** update span element with change in payment type option */
		variantChangePaymentType(){
			const paymentTypeBox = document.querySelector('.product-variant-payment-type-select');
			if (!paymentTypeBox) return;
			
			const radioButtons = paymentTypeBox.querySelectorAll('input[type="radio"].product-payment-type-radio');
			radioButtons.forEach(radio => {
				radio.addEventListener('change', () => {
					const selectedPaymentType = radio.getAttribute("data-payment-type")?.trim();
					if(selectedPaymentType=="installment"){
						const selectedVariant = [...document.querySelectorAll(".hidden-variant-dropdown div")].find(
							(div) => div.getAttribute("data-payment-type")?.trim() == selectedPaymentType
						);
						if(selectedVariant){
							const variantId = selectedVariant.getAttribute("Value");
							this.onChangeVariantforShipmentAmount(variantId, true);
						}  
					} else {
						this.onReloadingforShipmentAmount();
					}
				});
			});
		}

		/** update span element during page reloading */
		onReloadingforShipmentAmount(){
			const paymentTypeBox = document.querySelector('.product-variant-payment-type-select');
			if (!paymentTypeBox) return;
			
			const selectedRadio = paymentTypeBox.querySelector('input[type="radio"].product-payment-type-radio:checked');
			const selectedPaymentType = selectedRadio ? selectedRadio.getAttribute("data-payment-type")?.trim() : "";
			if(selectedPaymentType=="installment"){
				const selectedVariant = [...document.querySelectorAll(".hidden-variant-dropdown div")].find(
					  (div) => div.getAttribute("data-payment-type")?.trim() == selectedPaymentType
					);
					if(selectedVariant){
					  	const variantId = selectedVariant.getAttribute("Value");
						this.onChangeVariantforShipmentAmount(variantId, true);
					}  
			  
			} else {
			 const shipmentAmountBox = document.querySelector('.product-variant-shipment-amount');
			 if (shipmentAmountBox) {
				 const selectedText = shipmentAmountBox.value.trim();
				 const selectedVariant = [...document.querySelectorAll(".hidden-variant-dropdown div")].find(
					  (div) => div.innerHTML.trim() == selectedText
					);
					if(selectedVariant){
						const variantId = selectedVariant.getAttribute("Value");
						this.onChangeVariantforShipmentAmount(variantId);
					}
			 }
			}
			
		}

		/** fetch api endpoint to update span element
		 * sellingPlan info
		 */
		onChangeVariantforShipmentAmount(variantId, isInstallmentSection=false) {
			if(!variantId) {
				this.onClearSubscriptionDetails();
				return;
			} 
			const apiUrl = KROWN.settings.subscription_api.get_selling_plan_info_by_variant_id
			const spanElement = document.querySelector('.sub_details');
			const mappedIntervalToLocale = {
				"day": KROWN.settings.locales.days,
				"week": KROWN.settings.locales.weeks,
				"month": KROWN.settings.locales.months,
				"year": KROWN.settings.locales.years
			};
			fetch(`${jpapp.proxyUrl}${apiUrl}?variantId=${variantId}`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/javascript",
				},
			})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`API returned ${response.status}`);
				}
				return response.json();
			})
			.then((sellingPlanInfo) => {
				const { sellingPlan: { deliveryPolicy, originalIntervalCount, sellingPlanType  }, error } = sellingPlanInfo;
				const isInstallment = sellingPlanType === "installment";
				if(isInstallment){
					isInstallmentSection = true;
				}
				if (error) {
					console.log("unable to fetch selling plan info from getSellingPlanInfoByVariantId", error)
					return;
				}
				
				const deliveryPolicyIntervalElement = this.querySelector('.delivery-policy-interval');
				const deliveryPolicyIntervalCountElement = this.querySelector('.delivery-policy-interval-count');
				if (deliveryPolicyIntervalElement) {
					deliveryPolicyIntervalElement.value = deliveryPolicy.interval;
				}
				if (deliveryPolicyIntervalCountElement) {
					deliveryPolicyIntervalCountElement.value = isInstallment ? originalIntervalCount : deliveryPolicy.intervalCount;
				}
				const localizedString = KROWN.settings.locales.subscription_details;
				const updatedString = localizedString
					.replace('{{ interval }}', mappedIntervalToLocale[deliveryPolicy.interval.toLowerCase()])
					.replace('{{ intervalCount }}', isInstallmentSection ? originalIntervalCount : deliveryPolicy.intervalCount);
				
				if (spanElement) {
					spanElement.innerHTML = updatedString;
				}

				// Update subscription delivery element (Element 1) - same text as sub_details
				const iconSentenceDelivery = document.querySelector('.icon-sentence-text-subscription-delivery');
				if (iconSentenceDelivery) {
					iconSentenceDelivery.textContent = updatedString;
					if (iconSentenceDelivery.closest('.icon-sentence')) {
						iconSentenceDelivery.closest('.icon-sentence').style.display = '';
					}
				}

				// Update frequency note for "Per shipment" option (Element 2) - shorter format "every X Month(s)"
				const frequencyNote = document.querySelector('.frequency-note[data-js-interval-note]');
				if (frequencyNote) {
					const intervalNoteString = KROWN.settings.locales.subscription_interval_note
						.replace('{{ intervalCount }}', isInstallmentSection ? originalIntervalCount : deliveryPolicy.intervalCount)
						.replace('{{ interval }}', mappedIntervalToLocale[deliveryPolicy.interval.toLowerCase()]);
					frequencyNote.textContent = intervalNoteString;
					frequencyNote.style.display = '';
				}
			}).catch((e) => {
				console.log(e);
				this.onClearSubscriptionDetails();
			});
		}
	}

	if ( typeof customElements.get('variant-picker') == 'undefined' ) {
		customElements.define('variant-picker', VariantPicker);
	}

}